import React, { useEffect, useState } from "react";
import AccountReceipts from "../../components/BillingDetails/AccountReceipts/index";
import "./style.scss";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Tabination from "../../reusableComponents/Tabs";
import { Subscription } from "../../components/BillingDetails/YourSubscription/Index";
import MarketDataSubscription from "../../components/BillingDetails/MarketDataSubscription/Index";

const Billing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = [
    {
      name: "Your Subscription",
      path: "subscription",
    },
    {
      name: "Payment History",
      path: "payment-history",
    },
    {
      name: "Market Data Subscription",
      path: "market-Data-Subscription",
    },
  ];
  const [activeTab, setActiveTab] = useState(0);
  const location_path = useLocation();

  const pathnameSegments = location_path.pathname.split("/");
  const desiredPart = pathnameSegments[2];
  useEffect(() => {
    const currentLocation = "/" + desiredPart;
    switch (currentLocation) {
      case "/subscription":
        setActiveTab(0);
        break;

      case "/payment-history":
        setActiveTab(1);
        break;
      case "/market-Data-Subscription":
        setActiveTab(2);
        break;

      default:
    }
  }, [window.location.pathname]);
  return (
    <>
      <div className="billing">
        <Tabination
          variant={1}
          tabItems={items}
          showTabs={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          mainurl={"/billing-details/"}
        />
        <div className="billing">
          <Routes>
            <Route
              path="/"
              element={<Navigate to="subscription" replace={true} />}
            />
            <Route path="subscription" element={<Subscription />} />
            <Route path="payment-history" element={<AccountReceipts />} />
            <Route path="market-Data-Subscription" element={<MarketDataSubscription />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Billing;
